import { Component, Schema, defaultValue, type } from "yage/decorators/type";
import { checkCondition, incrementAchievement } from "./Achievements";
import { System } from "yage/components/System";
import { ComponentCategory } from "yage/constants/enums";
import { GameModel } from "yage/game/GameModel";
import { Achievement } from "../../schema/achievements/Achievements";
import { registerSystem } from "yage/components/ComponentRegistry";

@Component("TrackAchievementsOnKill")
export class TrackAchievementsOnKillSchema extends Schema {
  @type([Achievement])
  @defaultValue([])
  achievements: Achievement[];

  @type("number")
  @defaultValue(0)
  owner: number;

  @type("number")
  @defaultValue(0)
  killedEntity: number;

  @type("number")
  @defaultValue(0)
  killSource: number;
}

class TrackAchievementsOnKillSystem implements System {
  schema = TrackAchievementsOnKillSchema;
  type = "TrackAchievementsOnKill";
  category = ComponentCategory.ONKILL;

  run(entity: number, gameModel: GameModel) {
    const data = gameModel.getTypedUnsafe(entity, TrackAchievementsOnKillSchema);

    for (const achievement of data.achievements) {
      if (
        checkCondition(entity, achievement.condition, gameModel, {
          entity: data.killedEntity,
          source: data.killSource,
          owner: data.owner,
        })
      ) {
        const unlocked = incrementAchievement(entity, achievement, gameModel, 1);
        if (unlocked) {
          data.achievements = data.achievements.filter((a) => a.name !== achievement.name);
          if (!data.achievements.length) {
            gameModel.removeComponent(entity, this.type);
          }
        }
      }
    }
  }
}

registerSystem(TrackAchievementsOnKillSystem);
